import AddMeeting from "./AddMeeting";
import "./style/CreateMeeting.css";
import ViewMeeting from "./ViewMeeting";
import React, { useEffect, useState } from "react";
import {
  useNavigate,
  Navigate,
  useLocation,
  useSearchParams,
} from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import "./style/meetings-css.css";
import { updateStep } from "../../redux/actions/meetingActions/MeetingAction";
import { logOut } from "../../redux/actions/authActions/authAction";
import BackButton from "../Common/Backbutton";
const MeetingPage = React.memo(() => {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const [camefromPreviousPage, setCamefrompreviospage] = useState(
    location.state?.camefromPreviousPage || false
  );

  const isNewMeetingFromParam = searchParams.get("new") === "true";
  const stateData = location.state;
  const dispatch = useDispatch();
  const authData = useSelector((state) => state.auth);
  const navigate = useNavigate();
  if (authData.isInValidUser && authData.isInvalidUserChecked) {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("userData");
    localStorage.removeItem("rememberMe");
    dispatch(logOut());
    navigate("/login");
  }
  useEffect(() => {
    document.title = "Create Meeting: MinutesVault";

    return () => {
      dispatch(updateStep(0, false));
    };
  }, []);

  return (
    <>
      {stateData?.isNewMeeting || isNewMeetingFromParam ? null : (
        <Navigate to="/meeting-list" />
      )}

      <div className="main-content">
        <div className="row resp-col-reverse">
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 detail-col res-mt-2 resp-mt-2-employee">
            <div className="meeting-header-text line-height-h4">
              <h4>Meeting Preview</h4>
            </div>
            <ViewMeeting />
          </div>
          <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12 col-12 detail-col">
            <div className="meeting-header-text line-height-h4 res-head">
              <h4>Add Meeting Details</h4>
              <BackButton show={camefromPreviousPage} />
            </div>
            <AddMeeting />
          </div>
        </div>
      </div>
    </>
  );
});

export default MeetingPage;
